export default {"src":"/_next/static/media/flag-PE.d4e19ee5.svg","height":17,"width":24,"blurWidth":0,"blurHeight":0};